import getCollection from '../../../utils/db/getCollection'
import getDoc from '../../../utils/db/getDoc'
import { CATALOG_TAXONOMY_COLLECTION } from '../../../components/Products/components/CatalogTaxonomy/catalogTaxonomyConstants'
import { OUTLET_SHOP_ID } from '../outlet/outletCategoryConstants'
import { PREMIUM_ONLINE_SHOP_ID } from './giftFundCatalogPool'

const readShopRemains = (shop) => (Array.isArray(shop?.remains) ? shop.remains : [])

export const loadGiftFundCatalogAvailability = async () => {
  const [products, outletProducts, taxonomyNodes, premiumShop, outletShop] = await Promise.all([
    getCollection({ path: 'products', docIdName: 'id' }),
    getCollection({ path: 'outletProducts', docIdName: 'id' }),
    getCollection({ path: CATALOG_TAXONOMY_COLLECTION, docIdName: 'id' }),
    getDoc({ path: 'shops', docId: PREMIUM_ONLINE_SHOP_ID, docIdName: 'id' }),
    getDoc({ path: 'shops', docId: String(OUTLET_SHOP_ID), docIdName: 'id' }),
  ])

  return {
    products: Array.isArray(products) ? products : [],
    outletProducts: Array.isArray(outletProducts) ? outletProducts : [],
    taxonomyNodes: Array.isArray(taxonomyNodes) ? taxonomyNodes : [],
    remainsByShop: {
      [PREMIUM_ONLINE_SHOP_ID]: readShopRemains(premiumShop),
      [String(OUTLET_SHOP_ID)]: readShopRemains(outletShop),
    },
  }
}
